import React from "react";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  beam: {
    height: 8,
    width: 74,
    borderRadius: "2rem"
  },
  primary: {
    background: theme.palette.primary.main
  },
  secondary: {
    background: theme.palette.secondary.main
  }
}));

export default function Beam({ color }) {
  const classes = useStyles();
  return (
    <div
      className={clsx(classes.beam, {
        [classes.primary]: color === "primary",
        [classes.secondary]: color === "secondary"
      })}
    />
  );
}
